export default "__VITE_ASSET__C4LJ2qGw__"